<template>
    <v-chart  
    style="height:200px;"
    :auto-resize="true"
    ref="chart1"/>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart  } from "echarts/charts";
// import ECharts from 'echarts';
import {
    TitleComponent,
    ToolboxComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
use([
    TitleComponent,
    GridComponent,
    CanvasRenderer,
    PieChart,
    ToolboxComponent,
    TooltipComponent,
    LegendComponent,
]);
export default {
    name:'chartstatus',
    components:{
        VChart
    },
    provide: {
        [THEME_KEY]: "light"
    },
    props:{
       chart_data:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       title:{
           type: Number,
           required: true,
           default: ()=>{
               return ''
           }
       },
    },
    created(){
        setTimeout(()=>{
            this.setoption();
        },1000)
        
    },
    mounted() {
        this.$nextTick(()=>{
            this.$refs.chart1.clear();
            this.setoption();
            window.addEventListener("resize", this.resizeTheChart);
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeTheChart);
    },
    methods:{
        resizeTheChart() {
            if (this.$refs.chart1) {
                this.$refs.chart1.resize();
            }
        },
        setoption(){
            this.$refs.chart1.setOption(this.option, true);
        }
    },
    data(){
        return{
            option: {
                title: {
                    text: '30 June '+this.title+' Tax Lodgement',
                    left: 'center',
                    bottom:'bottom',
                    textStyle:{
                        fontWeight:'normal',
                        fontSize: 13,
                        lineHeight:0,
                        color:'#1c273c'
                    }
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'item',
                },
                series: [
                    {
                        name:'Number of Funds',
                        type: 'pie',
                        radius: ['40%','80%'],
                        center: ['50%', '50%'],
                        // roseType: 'area',
                        itemStyle: {
                            // borderRadius: 8,
                            // opacity: this.isfund? 0.5:0.8,
                            color:function(params) {
                                let colorList = [           
                                        '#e9d8a6','#94d2bd','#0a9396'                              
                                ];
                                return colorList[params.dataIndex]
                            }
                            
                        },
                        label: {
                            show: false
                        },
                        data: this.chart_data,
                        
                    }
                ]
            }
        }
    }
}
</script>